class PopularProductList {
  private dots: NodeListOf<HTMLSpanElement>;
  private liste: HTMLElement;
  private btnLeft: HTMLElement;
  private btnRight: HTMLElement;
  constructor(
    dots: NodeListOf<HTMLSpanElement>,
    liste: HTMLElement,
    btnLeft: HTMLElement,
    btnRight: HTMLElement,
  ) {
    this.dots = dots;
    this.liste = liste;
    this.btnLeft = btnLeft;
    this.btnRight = btnRight;

    this.liste.addEventListener("scrollend", () =>
      this.activerDots(
        Math.round(this.liste.scrollLeft / this.liste.offsetWidth),
      ),
    );
    this.btnLeft.addEventListener("click", () => this.naviguer(-1));
    this.btnRight.addEventListener("click", () => this.naviguer(1));
  }
  naviguer(direction: number) {
    const indexActuel = Math.round(
      this.liste.scrollLeft / this.liste.offsetWidth,
    );
    const nouvelIndex = Math.max(
      0,
      Math.min(this.dots.length - 1, indexActuel + direction),
    );
    this.liste.scrollTo({
      left: nouvelIndex * this.liste.offsetWidth,
      behavior: "smooth",
    });
  }
  activerDots(index: number) {
    this.dots.forEach((dot) => dot.classList.remove("active"));
    this.dots[index].classList.add("active");
  }
}

export { PopularProductList };
